// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__hp19y","content":"style_content__ugDNN","content_title":"style_content_title__78f++","content_attention":"style_content_attention__fbvIC"};